interface IAppointmentByType {
  id: string;
  name: string;
  count: number;
}

interface IChartProps {
  series: { name: string, data: number[] }[];
  categories: string[];
  count?: number;
}

interface NewPatientStats {
  [id: string]: {
    name: string;
    newPatients: number;
  };
}

export function convertAppointmentTypeToChartData(appointments: IAppointmentByType[]): IChartProps {
  // Extract categories (names)
  const categories = appointments.map(apt => apt.name);
  
  // Create single series for appointment counts
  const series = [{
    name: 'Appointments',
    data: appointments.map(apt => apt.count)
  }];

  // Calculate total count
  const totalCount = appointments.reduce((sum, apt) => sum + apt.count, 0);

  return {
    series,
    categories,
    count: totalCount
  };
}

export function convertNewPatientStatsToChartData(stats: NewPatientStats): IChartProps {
	// Extract non-null departments and their data
	if (!stats) {
		return {
			series: [],
			categories: [],
			count: 0
		};
	}
	const departments = Object.values(stats)
			.filter((dept): dept is { name: string; newPatients: number } => 
					dept !== null && dept.name !== null);

	// Create categories from department names
	const categories = departments.map(dept => dept.name);

	// Create series with new patient counts
	const data = departments.map(dept => dept.newPatients);
	const series = [{
			name: 'New Patients',
			data
	}];

	// Calculate total count
	const count = departments.reduce((sum, dept) => sum + dept.newPatients, 0);

	return {
			series,
			categories,
			count
	};
}
